import { Component, Inject, PLATFORM_ID } from '@angular/core';
import WertWidget from '@wert-io/widget-initializer';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { selectedLang } from '../../app.component';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { SwapStatus, wertLangs } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-wert-eth',
  templateUrl: './buy-eth-wert.component.html',
  styleUrls: ['./buy-eth-wert.component.scss'],
})
export class BuyETHWertComponent {
  token: string = environment.tokenName;
  walletAddress!: string;
  isBscChain = false;
  wertWidget!: WertWidget;
  SwapStatus = SwapStatus;
  mountError: boolean = false;
  currentStep: number = 1;

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    public modalRef: BsModalRef,
    private http: HttpClient,
    private dataService: PresaleDataService,
  ) {
    setTimeout(() => {
      this.showWidget();
    }, 500);
  }

  async showWidget() {
    console.log(this.isBscChain, this.walletAddress);
    this.currentStep = 1;
    let data = {
      walletAddress: this.dataService.walletAddress,
      commodity: this.isBscChain ? 'BNB' : 'ETH',
      network: this.isBscChain ? 'bsc' : 'ethereum',
    };

    if (isPlatformBrowser(this._platformId)) {
      this.http.post<{ sessionId: string }>(environment.wertOnRampUrl, data).subscribe(
        (res) => {
          const sessionData = res;
          const wertOptions = {
            partner_id: environment.partnerId,
            session_id: sessionData.sessionId,
            lang: wertLangs[selectedLang] || 'en',
            redirect_url: environment.domain,
            ...data,
          };
          console.log({ wertOptions, sessionData });
          //   const wertObj = {partner_id:environment.partnerId };
          //   console.log('wertOptions =', wertObj);

          this.wertWidget = new WertWidget({
            ...wertOptions,
            listeners: {
              loaded: () => {
                console.log('widget loaded:');
                this.modalRef.hide();
              },
              close: () => {
                console.log('widget closed:');
              },
              position: (data: { step: string }) => console.log('step:', data.step),
              'payment-status': (status: {
                status: string;
                payment_id: string;
                order_id: string;
                tx_id: string;
              }) => {
                console.log('payment-status:', status);
                if (status.status == 'success') {
                  this.wertWidget.removeEventListeners();
                  this.wertWidget.close();
                }
              },
              error: (err: any) => {
                console.log('error:', err);
              },
            },
          });
          this.wertWidget.open();
        },
        (err: any) => {
          console.log('wert error response', err);
          this.mountError = true;
        },
      );
    }
  }
}
